module.exports = __webpack_public_path__ + "static/img/6.25997a89.png";